import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from 'inversify';
import { Symbols } from '@/symbols';
import { E_CompanyChargeMode } from './CompanyService';
let CompanyAddItemService = class CompanyAddItemService {
    constructor(companyApi, authService) {
        this.companyApi = companyApi;
        this.authService = authService;
        /**
         * 创建公司
         */
        this.postCreateCompany = this.companyApi.postCreateCompany;
        this.getCheckCompanyName = this.companyApi.getCheckCompanyName;
        this.getSalesforceCompanyName = this.companyApi.getSalesforceCompanyName;
    }
    get companyChargeModes() {
        const chargeModes = [
            E_CompanyChargeMode.TRIAL,
            E_CompanyChargeMode.COMMERCIAL
        ];
        console.log(this.authService.IsAdmin, this.authService.IsSuperAdmin);
        if (this.authService.IsAdmin || this.authService.IsSuperAdmin) {
            chargeModes.push(E_CompanyChargeMode.COOPERATIVE);
            chargeModes.push(E_CompanyChargeMode.INTERNAL);
        }
        return chargeModes;
    }
};
CompanyAddItemService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CompanyApi)),
    __param(1, inject(Symbols.AuthService)),
    __metadata("design:paramtypes", [Object, Object])
], CompanyAddItemService);
export { CompanyAddItemService };
